import { Box, Paper, Typography } from "@mui/material";

import themeColorsDesingSystem from "assets/theme/ds-colors";

export default function ConfigSection({ title, description, children }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 2, md: 3 },
        mb: 3,
        borderColor: themeColorsDesingSystem.stone.main,
      }}
    >
      <Box mb={2}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: themeColorsDesingSystem.primary.main,
            fontSize: "1rem",
          }}
        >
          {title}
        </Typography>
        {description ? (
          <Typography
            variant="body2"
            sx={{
              mt: 0.5,
              color: themeColorsDesingSystem.gray.dark,
            }}
          >
            {description}
          </Typography>
        ) : null}
      </Box>
      {children}
    </Paper>
  );
}
